import type { ReactNode } from 'react'

import { Sentiment } from '@sidecar-components/types'

/**
 * ContentSection comes in three sizes: Default is a reasonably wide, centered
 * container Skinny is a reasonably thin, centered container (think login) Full
 * is full width, like a hero bar
 */
export enum ContentWidths {
  DEFAULT = 'default',
  SKINNY = 'skinny',
  FULL = 'full',
}

export interface ContentSectionProps {
  breathable?: boolean
  children?: ReactNode
  className?: string
  compact?: boolean
  sentiment?: Sentiment
  strong?: boolean
  testId?: string
  width?: ContentWidths
  wrapperClassName?: string
  [key: string]: any
}
